"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _urlregex = _interopRequireDefault(require("urlregex"));
var _publication = require("../common/utils/publication");
var urlProtocolRegExp = /^https?:\/\//;
var setup = function setup(_ref) {
  var latestAsset = _ref.latestAsset;
  return {
    description: 'Add a WSDL spec that describes the structure of a SOAP API to use in Anypoint Studio or Flow Designer.',
    flows: [{
      label: 'Upload a WSDL',
      fields: [(0, _publication.apiVersionField)(latestAsset), {
        name: 'mainFile',
        inputType: 'file',
        classifier: 'wsdl',
        extensions: ['.wsdl', '.xml'],
        required: true,
        hasMainFile: true,
        mainFileProperty: 'mainFile'
      }]
    }, {
      label: 'Use an external link',
      fields: [(0, _publication.apiVersionField)(latestAsset), {
        label: 'Service URL',
        placeholder: 'Paste the URL of the service here',
        name: 'assetLink',
        inputType: 'text',
        required: true,
        clientValidations: function clientValidations(_ref2) {
          var value = _ref2.value;
          if (!urlProtocolRegExp.test(value)) {
            throw new Error('The URL must start with correct protocol (http:// or https://)');
          }
          if (!(0, _urlregex.default)().test(value)) {
            throw new Error('The URL is not valid');
          }
          return null;
        }
      }]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map